import { API_BASE } from "../../config";
import { useParams } from 'react-router-dom';
import BottomTable from '../../components/Air/Zones/BottomTable';
import TopTable from '../../components/Air/Zones/TopTable';
import AdminLayout from '../../layout/AdminLayout'
import axios from 'axios';
import { useEffect, useState } from 'react';

const Zones = ({title}) => {

  const [data,setData] = useState(null);

  const {zoneId} = useParams()

  useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/air-client/zone/${zoneId}`);
      // console.log(res.data);
      setData(res.data.clients)
    } catch (error) {
      console.log(error);
    }
  };

  fetchData();
}, [zoneId]);

  return(
    <AdminLayout>
            <h3>{title}</h3>
             <div className='my-5'>
                {data && <TopTable data={data}/>}
             </div>
             <div className=''>
              {data &&    <BottomTable data={data}/>}
             </div>
    </AdminLayout>
  );
}
export default Zones
